import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import {UrlTransformer} from '../helpers/url-transformer';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class Cadeau extends ModelBase {
  public static readonly type = 'Cadeau';
  public readonly type = Cadeau.type;

  @autoserialize
  public id: number;

  @autoserialize
  public naam: string;

  @autoserialize
  public beschrijving: string;

  @autoserializeAs(UrlTransformer, 'link')
  public link: URL;

  @autoserialize
  public afstreepbaar = true;

  @autoserializeAs('afbeelding_url')
  public afbeeldingUrl: string;

  @autoserialize
  public afbeelding: string;

  @autoserialize
  public afbeeldingType: string;

  public afbeeldingDataUrl(): string {
    return typeof this.afbeelding === 'string' && this.afbeelding ? `data:${this.afbeeldingType};base64,${this.afbeelding}` : null;
  }
}
